import { captureException } from '@sentry/react';

export const catchErrorLog = (error: Error | unknown, context = 'unknown') => {
  if (process.env.NODE_ENV === 'production') {
    captureException(error);
  } else {
    console.error(`🚀 ~ [${context}]`, error);
  }
};
